module.exports = __webpack_public_path__ + "img/border.447a71db.png";